import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => createStyles({
  editButton: {
    width: '100px',
  },
  uppercaseField: {
    '& input': {
      textTransform: 'uppercase',
    },
  },
}), { name: 'PromotionCode' });

export default useStyles;
